// eslint-disable-next-line
import tw from "twin.macro";
import TeamSection from "../components/Sections/TeamSection";
import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const Teams = () => {
  return (
    <Layout>
      <Seo title="Our Team" description="Teamwork divides the task and multiplies the success." />
      <TeamSection />
    </Layout>
  );
};

export default Teams;
